<template>
  <cargo-dialog
    :title="title"
    :visible="previewFileData.visible"
    :can-maximize="canMaximize"
    custom-class="common-preview-dialog"
    append-to-body
    @close="closePreviewDialog"
    @fullscreen="fullscreenChange"
  >
    <div v-if="previewFileData.pdfSrc" class="pdf-img">
      <el-scrollbar>
        <pdf v-for="i in previewFileData.numPages" :key="i" :src="previewFileData.pdfSrc" :page="i" />
      </el-scrollbar>
    </div>
    <div v-if="previewFileData.excelSrc" :class="isMax ? 'max-plus-class' : ''">
      <excel :key="dialogKey" :src="previewFileData.excelSrc" :class="!isMax ? 'office-preview' : ''" />
    </div>
    <div v-if="previewFileData.wordSrc">
      <el-scrollbar>
        <doc :src="previewFileData.wordSrc" class="office-preview" />
      </el-scrollbar>
    </div>
    <div v-if="previewFileData.txtPre">{{ previewFileData.txtPre }}</div>
    <viewer v-else-if="previewFileData.photoList.length > 0" :images="previewFileData.photoList" class="preview-img">
      <img v-for="(item, index) in previewFileData.photoList" :key="index" :src="item">
    </viewer>
  </cargo-dialog>
</template>
<script>
import pdf from 'vue-pdf'
import excel from '@vue-office/excel'
import doc from '@vue-office/docx'
import '@vue-office/excel/lib/index.css'
import { findByFileId, convertFileByFileId } from '@/api/storage'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
export default {
  name: 'PreViewFileCommonDialog',
  components: { CargoDialog, pdf, excel, doc },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    },
    canMaximize: { type: Boolean, default: () => false },
    file: { type: Object, default: () => {} }
  },
  data() {
    return {
      previewFileData: {
        visible: false,
        numPages: '',
        photoList: [],
        pdfSrc: '',
        wordSrc: '',
        excelSrc: '',
        txtPre: ''
      },
      isMax: false,
      dialogKey: 0
    }
  },
  watch: {
    async visible(newVal) {
      if (newVal) {
        if (this.file) {
          await this.loadFile()
        }
      }
    }
  },
  methods: {
    async loadFile() {
      const imgType = ['png', 'jpg', 'jpeg', 'gif', 'webp']
      const fileType = this.getFileType(this.file.fileName)
      if (fileType === 'pdf') {
        const res = await findByFileId(this.file.fileId)
        if (res && res.data) {
          const URL = window.URL || window.webkitURL
          const pdfUrl = URL.createObjectURL(res.data)
          const loadingTask = pdf.createLoadingTask({
            url: encodeURI(pdfUrl),
            cMapUrl: 'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/',
            cMapPacked: true
          })
          await loadingTask.promise.then(pdf => {
            this.previewFileData.numPages = pdf.numPages
          })
          this.previewFileData.pdfSrc = loadingTask
          this.previewFileData.visible = true
        }
      } else if (imgType.includes(fileType)) {
        const res = await findByFileId(this.file.fileId)
        if (res && res.data) {
          const URL = window.URL || window.webkitURL
          const imgUrl = URL.createObjectURL(res.data)
          this.previewFileData.photoList = [imgUrl]
          this.previewFileData.visible = true
        }
      } else if (fileType === 'doc') {
        const res = await convertFileByFileId(this.file.fileId, 'docx')
        if (res && res.data) {
          this.previewFileData.wordSrc = res.data
          this.previewFileData.visible = true
        }
      } else if (fileType === 'docx') {
        const res = await findByFileId(this.file.fileId)
        if (res && res.data) {
          this.previewFileData.wordSrc = res.data
          this.previewFileData.visible = true
        }
      } else if (fileType === 'xls') {
        const res = await convertFileByFileId(this.file.fileId, 'xlsx')
        if (res && res.data) {
          this.previewFileData.excelSrc = res.data
          this.previewFileData.visible = true
        }
      } else if (fileType === 'xlsx') {
        const res = await findByFileId(this.file.fileId)
        if (res && res.data) {
          this.previewFileData.excelSrc = res.data
          this.previewFileData.visible = true
        }
      } else if (fileType === 'txt') {
        const res = await findByFileId(this.file.fileId)
        if (res && res.data) {
          const self = this
          const reader = new FileReader()
          reader.onload = function() {
            self.txtPre = reader.result// 获取的数据data
            console.log('reader.result', reader.result)
          }
          reader.readAsText(res.data)
          this.previewFileData.visible = true
        }
      }
    },
    // 处理文件后缀名
    getFileType(fileName) {
      let fileType = ''
      if (fileName.indexOf('.') === -1) {
        console.log(this.fileFormat)
        if (this.fileFormat.indexOf('docx') !== -1 || this.fileFormat.indexOf('docx') !== -1 || this.fileFormat.indexOf('word') !== -1 || this.fileFormat.indexOf('xls') !== -1 || this.fileFormat.indexOf('xlsx') !== -1 || this.fileFormat.indexOf('pptx') !== -1) {
          fileType = 'officeType'
        } else if (this.fileFormat.indexOf('pdf') !== -1) {
          fileType = 'pdf'
        } else if (this.fileFormat.indexOf('txt') !== -1) {
          fileType = 'txt'
        }
      } else {
        const arr = fileName.split('.')
        fileType = arr[arr.length - 1].toLowerCase()
      }
      return fileType
    },
    closePreviewDialog() {
      this.previewFileData.pdfSrc = ''
      this.previewFileData.numPages = ''
      this.previewFileData.photoList = []
      this.previewFileData.excelSrc = ''
      this.previewFileData.wordSrc = ''
      this.previewFileData.txtPre = ''
      this.previewFileData.visible = false
      this.$emit('close')
    },
    fullscreenChange(isMax = false) {
      this.isMax = isMax
      // 定义一个key，强制刷新组件渲染
      this.dialogKey = this.dialogKey + 1
    }
  }
}
</script>
<style lang="scss" scoped>
  .common-preview-dialog.is-fullscreen {
    height: 100%;
    .el-dialog__body {
      height: 100%;
      .pdf-img{
        height: 100%;
        .el-scrollbar{
          height: 100%;
        }
      }
    }
  }
  .office-preview {
    width: 100%;
    height: 100%;
    min-height: 600px;
    border: none;
  }
  .preview-img{
    height: 100%;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
      width: auto;
      max-width: 100%;
      min-width: 120px;
      min-height: 120px;
      height: auto;
    }
  }
  .pdf-img{
    height: 550px;
    .el-scrollbar{
      height: 550px;
      /deep/ .el-scrollbar__wrap{
        overflow-x: hidden;
      }
      /deep/ .el-scrollbar__bar{
        opacity: 1;
      }
    }
  }
  /deep/ .max-plus-class{
    .vue-office-excel-main{
      width: 100%!important;
      height: 100%!important;
      .x-spreadsheet-sheet{
        width: 100%!important;
        height: 100%!important;
      }
      .x-spreadsheet-overlayer{
        width: 100%!important;
        height: 100%!important;
      }
      .x-spreadsheet-table{
        width: 100%!important;
        height: 100%!important;
      }
    }
  }
</style>
